import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "wonderbly-components/lib/Icon";

const addEventListeners = (el, callback) => {
  if (el) {
    el.addEventListener("transitionend", callback);
    el.addEventListener("-webkit-transitionend", callback);
  }
};

class HeidelbergPage extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    imageUrl: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    nearActive: PropTypes.bool.isRequired,
    children: PropTypes.node,
  };

  state = {
    wasActive: false,
    animating: false,
  };

  constructor(props) {
    super(props);
    this.timeoutId = null;
    this.ref = React.createRef();
  }

  handleTransitionEnd = () => {
    this.setState({
      animating: false,
      wasActive: false,
    });
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  componentDidMount() {
    addEventListeners(this.ref.current, this.handleTransitionEnd);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      animating: this.state.animating || this.props.active !== newProps.active,
      wasActive: this.props.active && !newProps.active,
    });
    // }
    // Need to add this here, as there is technically no longer a transitionEnd as we don't transition the rotate
    // value of the active page, so we set the timeout when the animation ends. 900 should match exactly the CSS
    // animation length.
    if (this.props.active) {
      this.timeoutId = setTimeout(this.handleTransitionEnd, 900);
    }
  }

  shouldNotRenderImage() {
    return (
      !this.props.imageUrl ||
      (this.props.id !== 2 && // 2nd page has CSS that expands the parent div
        !this.props.active &&
        !this.state.animating &&
        !this.props.nearActive)
    );
  }

  render() {
    return (
      <div
        ref={this.ref}
        onClick={this.props.handleClick}
        className={cx("Heidelberg-Page", {
          "is-active": this.props.active,
          "is-animating": this.state.animating,
          "was-active": this.state.wasActive,
        })}
      >
        <div>
          <Icon icon="loading" />
          {!this.shouldNotRenderImage() && (
            <img
              className="heidelberg-book-image"
              alt={`Book page ${this.props.id}`}
              src={this.props.imageUrl}
            />
          )}
          <div className="click-blocker" />
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default HeidelbergPage;
